import phdapiCartService from './phdapiCartService';

export function getCartService() : CartService {
  return process.env.REACT_APP_EMBEDDED === 'true'
    ? lazyLoadAngularBackedService()
    : phdapiCartService;
}

function lazyLoadAngularBackedService() : CartService {
  // lazy-requiring this because the angular localization service
  // blows up if Nextjs tries to run it server-side
  // (currently depends on the global window object, which is not available server-side)
  /* eslint-disable  global-require */
  return require('./angularCartService').default;
}

export default getCartService();
